import React from "react";

function HospitalBed() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="svg20887"
      width="71.0833"
      height="72"
      version="1.1"
      viewBox="0 0 39.76 40.275"
    >
      <style id="screen-color-temperature-style" type="text/css"></style>
      <g id="layer8" display="inline" transform="translate(47.094 -128.696)">
        <path
          id="path21673"
          fill="#000"
          strokeWidth="0.265"
          d="M-35.376 128.696c-1.773-.013-3.242 1.008-4.725 1.825-2.21 1.086-4.458 2.324-6.23 4.305-.838 1.696-.723 3.982-.723 5.83v1.276c-.096.248 0 .61.076.876.895 1.086.571 2.362.876 3.677-.324.438-.4 1.048-.248 1.6.286.343.705.343 1.124.324.458-.23.648-.686.724-1.124v-1.2c.038-.134-.038-.305.095-.4 2.21 2.114 4.553 4.438 6.534 6.553-.114 1.428-.457 2.762-.324 4.305-.476.495-1.371.553-1.524 1.353-.019.514-.038 1.047.4 1.352.381.172.934.057 1.277.095 0-.095-.019-.21.076-.247.057.133.229.057.324.076.628-.553 1.276-.743 1.753-1.505l.076.076c.057.153-.095.21-.076.324.895.781-.743 1.105-.553 2 0 .4.248.686.553.953.743.19 1.448.057 2-.648.248-.648 1.067-.61 1.448-1.276.19-.476.095-1.239-.553-1.277.229-.304-.133-.99.324-1.047 2.781 2.553 5.887 4.781 8.534 7.334l.172 3.353c-.076.38-.267 1.01.152 1.276.286.171.686.343 1.029.152.438-.266.457-.723.552-1.124-.324-.533-.038-1.352-.247-1.98l.171-.23.153.153c.076 0 .19.019.228-.076.362.362.857 0 1.277 0 2.019-1.543 4.172-2.725 6.305-3.982 1.677-.552 3.086-1.714 4.705-2.4.457.857-.495 1.333-.4 2.153.362.304.533.647 1.048.628.305-.095.553-.266.8-.552.172-.324.02-.686-.171-.952l.076-1.753c.323-.438.99-.686.952-1.353v-1.2c-.19-1.028-.229-1.828-.552-2.8-.362-.857-1.334-1.258-2.153-1.524-.647-1.258-1.981-2.229-3.105-3.105a81.842 81.842 0 01-4.381-4.153c-2.115-2.077-4.382-4.02-6.058-6.382-1.124-.724-1.848-2.4-3.353-2.229-.667.229-.038.8-.228 1.124l-1.2-1.124c-1.449-.819-2.363-2.667-4.077-2.952.095-.21-.21-.362 0-.553-.343-1.18-.515-2.457-1.524-3.353l-.629-.4a4.615 4.615 0 00-.78-.072zm.327 1.973c.062 0 .12.014.148.08l-.019.02c.134-.134.362-.095.477 0 .495.705.38 1.752.4 2.553-.248.228-.591.228-.877.304.057-.553-.095-1.01-.152-1.505.057-.419-.077-.953-.153-1.448.048.01.115-.005.176-.005zm-1.795.576h.02l.228 3.105c-.381.19-.8.267-1.124.552-.381-.819-.19-1.847-.477-2.704-.133-.839.896-.687 1.353-.953zm-3.257 1.6c.342.648.304 1.6.628 2.305-.114.133.248.381 0 .553l.076.076c-.533.171-.914.704-1.504.723-.115-.914-.229-1.828-.4-2.704l.076-.076-.076-.077c.362-.362.8-.533 1.2-.8zm-2.953 1.752c-.171 1.296 1.543 3.163-.553 3.906.305-1.353-1.409-3.124.553-3.906zm-2.572 2.4c.134.191.038.477.248.63l-.076.076c.19.666.229 1.371.552 2a2.276 2.276 0 00-.629.876l-.171-.152c-.172-.61.02-1.372-.152-1.982.114-.552.133-.876.228-1.447z"
        ></path>
      </g>
      <g id="layer1" display="inline" transform="translate(47.094 -128.696)">
        <g
          id="ƒŒƒCƒ_x201e__x0081__x005b__x0020_1"
          transform="matrix(.26458 0 0 .26458 -47.714 127.999)"
        >
          <g id="g21665">
            <path
              id="path21661"
              fill="#000"
              d="M79.676 20.621c4.176 3.96 11.304 7.992 10.44 14.615-.504 2.664.072 5.688-.432 8.352.144.144.288.288.216.504l-.216.216c.288.432 0 1.296-.216 1.872-.792.936-2.304 1.224-3.24.432-1.584-2.304.072-5.256-.504-7.632.792-.72-.504-1.368.288-2.088-.288-2.664-.072-5.615-3.024-6.983h-.216c-.36 1.08-.36 2.591 0 3.743l-.288.216c.072 2.808 1.152 6.48-1.368 8.136-1.152.36-1.8-.72-2.376-1.152.432-.936-1.08-1.296-.216-2.088-.648-.432.432-1.08-.216-1.656-.432-4.104 3.24-9.575-1.368-12.311l-1.872-1.152c-.432 3.24-.072 6.624-1.152 9.503-.72 1.08-1.8.864-2.808.432-1.368-1.728-.216-4.103-.504-6.263.432-2.664 1.44-6.768-.936-8.856-.648-.144-1.08-.648-1.872-.432-1.728 2.232.504 5.976-1.872 7.92-.72.504-1.656.072-2.304-.504l-.72-1.368 1.152-9.288c.72-.936 1.296-2.16 2.592-2.304 5.184 1.152 8.28 5.76 13.032 8.136z"
            ></path>
            <path
              id="path21663"
              fill="#bccbd4"
              d="M77.588 20.189c3.816 2.88 7.776 6.624 10.944 10.224l.72 1.871-.288 13.032c-.288.648-1.152 1.584-1.872.936-1.008-.432-1.008-1.728-.936-2.808.36-3.96.36-7.416 0-11.376-.72-1.655-2.448-1.727-3.456-3.023l-1.152 1.152c.792.504-.504 1.08.216 1.655v3.24c.792 1.44-.504 2.952.216 4.392-.144.936-.504 1.44-1.368 1.872-1.872-.432-1.08-2.808-1.656-4.176.072-4.392 3.312-10.367-1.872-13.031-.72-.504-1.512-.792-2.088-1.656-1.8.648-.432 2.88-1.152 4.176l.216.216c-.504.216.072.576 0 .936-.432 1.872.144 4.103-1.368 5.543-.504-.216-1.296 0-1.656-.72-.072-4.319 1.008-8.495.936-12.527-1.08-1.296-2.376-3.24-4.392-2.808-1.872 2.304-1.08 4.824-1.656 7.704-.36.072-1.08.864-1.656.216-.72-1.584-.72-4.032 0-5.544.072-.936-.144-2.592.288-3.744.288-1.224.72-1.944 1.872-2.592 4.608.648 6.984 5.112 11.16 6.768z"
            ></path>
          </g>
          <g id="g21671">
            <path
              id="path21667"
              fill="#000"
              d="M126.043 63.316a165.566 165.566 0 0014.4 9.504c.792 1.08 1.296 2.232 1.368 3.456.936 1.584.144 3.816.72 5.616-.216 1.008-.72 2.088-.216 3.024-.144.144-.288.288-.288.504l.288.216c-.792.864.504 1.656-.288 2.52l.288.216c-.504.216.072.576 0 .936-.72.72-.936 1.944-2.088 2.088-1.008 0-1.872-.792-2.304-1.656-.072-.36.216-.936-.216-1.152l.216-.216c-.36-3.6-.36-7.56 0-11.16-.648-.504-1.152-1.368-1.872-1.656-.864 3.528 0 7.776-1.872 10.944-.504.288-1.08.792-1.656.288-1.656-.792-.504-2.736-1.152-3.96-.144-3.312 1.152-6.336.72-9.504.648-.432-.216-.792 0-1.368-.864-.648-1.656-1.224-2.52-1.872-.792 4.104-.36 8.064-1.368 12.096-.288.936-1.584 1.152-2.304.72l-.72-.72a99.037 99.037 0 010-14.616c-.72-.792-1.44-1.44-2.52-1.152-1.152 1.512.144 3.384-.216 4.896-.792 1.728 1.8 5.4-1.368 5.544l-.216-.216c-.288.504-.575-.072-.935 0-1.368-1.008-1.296-3.384-.936-5.112-.792-1.224.504-2.52-.216-3.744.432-.216.216-.72.216-1.152l-.216-.216.216-.216c-.648-1.008.216-2.016.216-3.024 1.367-3.816 5.039-.864 6.983.216z"
            ></path>
            <path
              id="path21669"
              fill="#bccbd4"
              d="M128.347 66.124c4.032 2.232 7.488 5.76 11.592 7.704 1.08 1.368 1.368 3.168 1.656 4.896v3.456c-.504 2.448.072 5.544-.432 7.632-.648.792-1.08.504-1.872.216-1.08-1.728-.792-4.104-.936-6.048-.36-3.24 2.16-8.64-2.52-10.008-.648.792-.648 2.16-.936 3.24l-.432 7.2c-.288.504-.288 1.224-.936 1.656-.792.216-.792-.792-1.152-1.152.072-1.008-.216-2.808.216-3.96l-.216-.216c-.504-3.744 3.528-10.224-2.592-11.592-.576-.072-1.296 0-1.368.72.288 2.52-.504 5.4-.216 7.92-.504.216.072.576 0 .936-.432 1.512-.072 2.52-1.152 3.744-.576-.216-1.224-.504-1.368-1.152l.288-14.184c-.864-1.152-2.016-1.656-3.456-1.368l-.72.936.216.216c-.432 2.592-.144 5.976-.216 8.136.648.432-.216.72-.216 1.152-.791.216-1.295-.36-1.871-.936.072-3.744-.216-8.208.216-12.096.864-1.8 2.807-.504 3.959-.216l4.68 3.24z"
            ></path>
          </g>
          <g id="g21829">
            <path
              id="path21675"
              fill="#bccbd4"
              d="M48.644 3.845c5.904 2.232 7.272 8.856 8.136 14.472-.144 1.656-2.016.576-3.024.864l.288-.288c-.504-3.96-1.008-8.064-4.248-10.584-1.44-.288-2.664-.216-3.96.288-1.008 1.44.576 3.6.288 5.112-.072.288.144.432.288.576l-.288.288c.216 2.376.864 4.464.648 6.912l-3.312 1.8c-.288-3.672-.432-7.488-1.512-10.872.504-.288.216-1.008.36-1.512l-1.512-.864c-2.376 1.296-4.968 2.232-7.272 3.96.504 4.536 1.368 8.856 2.088 13.248-1.008.144-1.8 1.008-2.736 1.512-.72-2.088-1.008-4.392-1.512-6.624.216-1.512-.36-3.384-.576-5.112-.648-.432-1.295-1.872-2.087-.864-2.088 1.512-4.104 3.096-6.336 4.248.648 4.32 1.224 8.64 1.8 12.959l-3.024 1.8c-1.368-3.743-.936-8.567-2.736-12.383-2.448.648-3.888 3.816-6.336 4.824.216 3.168 1.296 6.335.936 9.359 1.224.864.144 2.736.864 3.888l-1.8 1.8c-1.152-.504-.288-1.8-1.224-2.376.576-.36-.576-1.152 0-1.512-.576-2.736-1.152-5.544-2.088-8.135-2.952.288-2.232 4.247-3.312 6.335.504.504.504 1.584 0 2.088-.144.144-.36.288-.288.576l.288.288c-1.008 1.296.72 2.664-.288 3.96.864 3.456 2.232 7.848 1.224 12.024l1.512 3.024c9.648 9.072 19.224 19.656 29.591 29.232-.072.504.216 1.224-.288 1.512L10.989 63.46c-2.736-1.224-4.104-4.392-6.336-6.048-.648-2.304-1.296-5.04-.576-7.488-.72-7.488-.36-15.264 1.512-22.031 7.2-8.352 16.56-14.112 25.919-18.36 4.608-2.52 9.648-6.048 15.408-5.472l1.8-.288z"
            ></path>
            <path
              id="path21683"
              fill="#cedee7"
              d="M68.876 28.253c-2.736-.504-5.976-.576-7.848 1.8-1.728-.288-3.168-.72-4.824 0-.72-3.024-3.744-5.616-6.048-7.488 2.952-1.512 6.48-3.456 9.936-1.8 3.168 1.872 5.976 4.68 8.712 7.56z"
            ></path>
            <path
              id="path21685"
              fill="#fff"
              d="M53.756 28.253c0 1.152 2.592 1.944.864 3.024-1.872-2.592-4.896-6.336-8.136-7.56 3.024-1.656 5.328 2.664 7.272 4.536z"
            ></path>
            <path
              id="path21687"
              fill="#fff"
              d="M53.468 32.5c-1.008 3.744-4.104 6.408-7.272 8.784-4.752 2.304-9.432 4.608-14.184 6.912-3.527-3.744-6.983-7.848-10.871-10.872 6.768-5.616 15.191-8.423 22.895-12.671 3.96.576 7.704 4.248 9.36 7.847z"
            ></path>
            <path
              id="path21691"
              fill="#b28d7c"
              d="M67.364 29.477l.288-.288c3.528 1.224 8.424 3.095 9.072 7.487.288 1.368-.216 2.736.576 3.6 1.152.576 2.808 1.224 3.024 2.736-.864 1.728.072 4.752-2.736 5.112-.072-1.152-.432-2.088-1.224-3.024-2.088.504-1.872-2.232-3.6-3.024-2.016 0-3.096-1.728-3.888-3.312-.288 0-.72-.072-.936.36-.288.792.504 1.152.648 1.8-1.872-.288-2.376-2.736-3.6-4.248-1.512.936.216 1.944.288 3.024l.648.576c-1.584-1.8-4.104-3.312-3.96-5.76-.288-.504-1.008-.216-1.512-.288-.072 1.872-1.944 2.232-3.312 2.736-.36-.504-.864-.648-1.512-.648-.864.72-1.368 1.512-1.512 2.376l.288.36c-.216-1.008-2.232-.36-1.512-2.088 1.44-1.944 1.8-4.824 4.536-5.759.864-.864 1.584.36 2.736 0 .216.863-.576 1.943.576 2.375 1.224-2.663 3.528-5.111 6.624-4.247z"
            ></path>
            <path
              id="path21693"
              fill="#fefefe"
              d="M101.132 53.884c5.184 8.712 12.816 16.128 19.871 23.544 1.656 3.456 5.616 6.696 3.6 10.872-2.88 3.6-8.063 2.736-11.447 5.76-8.208 1.152-15.624 4.248-23.544 6.048-1.296 1.008-2.088.504-3.312 1.512l-.288-.288c-2.808 1.584-5.616 3.24-8.424 4.824-.072 1.152-2.952 1.872-1.224 3.024 6.984-7.2 16.992-7.992 25.632-11.448 1.656.36 3.312-1.224 5.112-1.512 5.112-.504 9.792-2.16 14.183-4.536.792.288 1.944-.288 2.736-.864 1.008-1.224 2.952-2.376 2.088-3.96 1.08-2.808-1.296-4.968-2.376-7.272-6.983-8.928-15.839-16.272-21.095-25.92-.792.072-.648-.864-.936-1.224 7.92 7.632 15.912 15.264 23.831 22.896 3.096 1.8 5.328 5.472 8.424 7.272 2.592 2.448 6.408 4.968 7.272 8.424-13.68 4.248-26.135 11.088-37.727 20.52-5.04 3.6-7.632 9.36-8.136 15.407-.072 1.152-1.44 1.8-2.088 2.736-5.976-.432-9.576-6.408-14.472-9.359l-7.56-8.136c-1.296-3.6-.36-7.632 1.512-10.584.864.864.864 3.312 2.376 2.736-.216-1.296-.576-2.52-1.8-3.312 3.528-2.736 8.208-2.88 11.808-5.688 3.744-2.088 4.392-5.832 5.112-9.36 2.16.504 4.464 2.736 5.4 4.248.648-.36.648-1.008.36-1.512l-4.248-3.6c-2.592.432-.936-2.592-1.8-3.6-2.88-6.408.216-13.32 0-20.16 2.448 3.024 6.408 5.256 8.424 8.712.36-.072 1.008.216 1.224-.288-3.456-4.968-9.936-7.848-10.872-13.896-1.728-7.92-7.92-13.968-9.936-21.672-.072-1.152-.072-2.376 1.224-2.735 8.856 4.895 15.84 14.111 21.096 22.607z"
            ></path>
            <path
              id="path21697"
              fill="#cedee7"
              d="M80.036 40.348c-.864-1.008-1.728-.432-2.088-1.8-.072-.36.216-1.584-.288-2.088 1.296.864 1.944 2.52 2.376 3.96z"
            ></path>
            <path
              id="path21699"
              fill="#fde7dd"
              d="M67.94 42.148c1.728.288 3.384.864 5.112 1.8-.072.288.144.432.288.576.072.36-.216 1.584.288 2.088.936.144 2.232-.36 2.376.864.288.792-.576 1.008-.864 1.512-3.024-1.152-3.96 1.728-5.76 3.024-3.312 1.656-7.848.72-11.16-.36-3.96-2.736-4.104-6.696-3.024-10.872.072-.864.864-1.584.576-2.736 1.872.864 3.744-.072 5.112-1.512 1.8 2.448 3.6 5.328 6.912 5.472z"
            ></path>
            <path
              id="path21701"
              fill="#fff"
              d="M30.572 48.772c-2.159 2.952-1.943-1.656-3.959-2.088l-8.136-7.488 1.224-1.224c4.248 2.88 7.632 7.632 10.871 10.872z"
            ></path>
            <path
              id="path21703"
              fill="#cedee7"
              d="M53.756 40.348c.072.936-.072 1.728-.576 2.376.144.648.144 1.944-.36 2.736 1.152 2.088 1.296 4.68 3.312 6.048-2.952 1.728-1.728 6.192-3.312 9.072.216 3.384-.36 6.408-.576 9.648.216 1.152-.36 2.664-.576 3.96.072 1.872-1.08 3.6-2.736 4.536-2.88 1.008-5.832 1.872-8.136 4.248l-.936.864c-6.192-4.968-11.159-12.312-17.783-16.92C17.325 62.02 11.925 57.34 8.253 51.22c1.584-4.248 4.608-8.208 8.712-10.872 4.392 3.456 8.352 6.336 11.448 11.16 2.015.504 2.015-2.376 4.247-1.512 6.12-4.104 12.96-6.192 18.72-11.16 1.296.072.864 2.088 2.376 1.512z"
            ></path>
            <path
              id="path21705"
              fill="#000"
              d="M59.732 41.428v.648c-1.008.144-1.008-2.376-3.312-.864l-.36.216c.432-1.152.864-1.008 1.584-1.368.36 0 1.8.144 2.016 1.368z"
            ></path>
            <path
              id="path21707"
              fill="#cedee7"
              d="M87.596 69.58c.432 3.024-.936 6.408 0 9.648.72 2.376 2.448 5.04.864 7.56-.432-.576-1.008-.936-1.8-.936 1.008-1.152.72-3.168.288-4.536-.504-2.592-.072-5.544-1.512-7.848 1.152-1.584-.864-2.664-.648-4.248-.36-2.232-.432-4.752-.864-6.624 0-.864-.288-2.304-.576-3.312-1.728-3.24-4.608-6.984-8.136-8.424 2.088-.864 4.896-1.008 6.048-3.6-.504-1.584.864-2.376.576-3.96 3.672 7.992 9.288 16.416 5.76 26.28z"
            ></path>
            <path
              id="path21709"
              fill="#000"
              d="M58.94 43.732c.144.864-.072 1.296-.864 1.512-.792-.288-.936-.432-1.224-1.224.072-1.008 1.728-1.296 2.088-.288z"
            ></path>
            <path
              id="path21711"
              fill="#000"
              d="M66.284 42.364l-.288.576c.864.576 1.944-1.728 3.312.576l.216.36c.072-1.224-.36-1.224-.936-1.872-.36-.144-1.656-.576-2.376.36z"
            ></path>
            <path
              id="path21713"
              fill="#000"
              d="M66.212 45.1c-.144.864.072 1.296.864 1.512.792-.288.936-.432 1.224-1.224-.072-1.008-1.728-1.296-2.088-.288z"
            ></path>
            <path
              id="path21715"
              fill="#000"
              d="M62.18 50.572c1.008-.216 1.656-1.152 2.304-.648-.504.648-1.872 1.728-2.88 1.512-1.656 0-2.16-.936-2.664-2.088h.648c.432.72 1.008 1.44 2.52 1.224z"
            ></path>
            <path
              id="path21717"
              fill="#ffe6b1"
              d="M82.412 60.868c1.152 7.92 2.664 15.696 3.312 23.832-1.944 1.152-4.248 2.448-6.624 1.512-.648.72-1.368-.072-2.088 0-.72-2.088 0-5.184-.648-6.912l.36-.288c-1.008-4.968-.216-10.944-3.312-14.76-.216 1.368.36 3.024.576 4.536 1.224 6.264 1.512 13.32.936 19.944-.936 1.224-1.584 3.6-3.6 3.312-5.328-6.192-11.808-11.016-18.72-14.184 3.384-4.248 6.12-9.504 4.536-15.048.504-.504.504-1.584 0-2.088l-.288-.36c.504-.216.216-.792.288-1.224-.144-.36-.576-.288-.864-.288l-.576.576c.216 3.816 1.008 8.568-.648 12.096L53.54 73.9c2.016-6.984-.504-14.616 3.312-20.808 1.296-.288 1.224 1.584 1.8 2.376 2.376.36 1.44 5.04 4.536 3.6.648-.432.936-1.08.936-1.8l-.288-.288c.648-.432.936.864 1.512 0l.288.288c2.232-2.808 5.112-3.6 7.56-6.336 3.312 2.232 8.568 5.328 9.36 9.936z"
            ></path>
            <path
              id="path21719"
              fill="#f2e2d3"
              d="M38.996 84.988l-1.224 1.8L8.541 57.556c-.648-1.152-1.296-2.664-.648-3.888 9 12.096 21.6 20.52 31.103 31.392z"
            ></path>
            <path
              id="path21721"
              fill="#ffe6b1"
              d="M61.028 54.244c-.216.648-1.584.864-1.512-.36z"
            ></path>
            <path
              id="path21723"
              fill="#ffe6b1"
              d="M66.788 54.532c-.72.864-1.728 1.656-2.736.864l-.648-.576c1.152-.072 2.376.216 3.312-.288z"
            ></path>
            <path
              id="path21725"
              fill="#fff"
              d="M62.252 56.908c.072.288-.144.432-.288.576l-.288-.576z"
            ></path>
            <path
              id="path21727"
              fill="#bccbd4"
              d="M10.701 66.556a9.183 9.183 0 010 3.96c-1.152-1.656-4.464-.144-3.6-3.312.216-.864-.36-2.376 0-3.312l-.576-2.376c1.44 1.728 4.824 2.736 4.248 5.112z"
            ></path>
            <path
              id="path21729"
              fill="#000"
              d="M63.116 67.78c-.504.72-1.224 1.008-2.088.864-1.44-.864-1.152-2.376 0-3.024 1.656-.72 1.8 1.224 2.088 2.088z"
            ></path>
            <path
              id="path21731"
              fill="#fff"
              d="M61.964 67.204l-.288.288-.36-.648c.36-.072.504.144.648.36z"
            ></path>
            <path
              id="path21733"
              fill="#000"
              d="M49.868 72.028h-.576l-.936-2.736c.36.648 2.232 1.296 1.512 2.736z"
            ></path>
            <path
              id="path21735"
              fill="#a4a6a8"
              d="M10.989 72.892c.72 1.512-1.368 1.872-1.512 3.024-1.008-.216-3.168.648-3.024-1.224.072-1.512-.288-3.384 1.512-3.96 1.296.216 2.808.648 3.024 2.088z"
            ></path>
            <path
              id="path21737"
              fill="#000"
              d="M45.908 77.428c-.864-1.296-.72-3.024-1.8-4.248l.36-.576c.36 1.656 2.16 3.096 1.512 4.824z"
            ></path>
            <path
              id="path21739"
              fill="#000"
              d="M71.54 78.364c-1.368-.648-2.736-2.736-4.248-3.6-.72-1.008-3.456-.288-2.736-2.088 2.592 1.296 5.472 2.952 6.912 5.76z"
            ></path>
            <path
              id="path21741"
              fill="#000"
              d="M9.189 74.116c-.576 1.368-1.44-.216-2.088-.288-.288-1.296 2.808-1.512 2.088.288z"
            ></path>
            <path
              id="path21743"
              fill="#000"
              d="M61.676 74.404c.144.864-.216 1.584-.936 2.088-1.296.36-2.232-.504-2.736-1.512-.144-1.224 1.224-1.224 1.8-1.8 1.008-.216 1.656.36 1.8 1.224z"
            ></path>
            <path
              id="path21745"
              fill="#000"
              d="M42.02 76.78v.576c-.864-.072-.864-1.512-1.512-2.088l-.936-.864c1.512-.216 1.944 1.44 2.376 2.376z"
            ></path>
            <path
              id="path21747"
              fill="#fff"
              d="M60.452 74.98c-.288-.072-.432.144-.576.288l-.288-.288c0-.36.504-.504.864-.576z"
            ></path>
            <path
              id="path21749"
              fill="#000"
              d="M69.452 80.452v.864c-1.728-.288-1.584-2.376-2.376-3.6l-1.8-2.088.288-.36c1.728 1.296 2.664 3.456 3.96 5.112z"
            ></path>
            <path
              id="path21751"
              fill="#ffe6b1"
              d="M66.788 88.876c.576 3.168-3.096 3.744-4.824 5.112-2.592 1.08-5.976 1.296-7.272 4.248-.288 5.04.792 10.656-.864 15.048-1.296 1.512-3.456 1.008-5.112 1.512-4.752-.72-.936-5.904-2.088-9.072.36-.36-.144-1.152 0-1.8.216-4.68.504-9.432 2.088-13.608l6.336-5.112-.864-.864c-10.8 3.312-8.064 14.904-9.36 23.544.144.144.36.288.288.576-1.728 1.008-4.392.648-6.336.288-1.224-.36-1.584-1.656-1.8-2.736.144-.144.36-.288.288-.576l-.288-.36c.504-.432.36-1.368 0-1.8.36-5.616 1.584-10.872 2.376-16.272 2.088-4.896 7.632-5.184 11.448-7.848 5.904 1.8 11.304 5.472 15.984 9.648z"
            ></path>
            <path
              id="path21753"
              fill="#fde7dd"
              d="M87.884 88.876c-.792.144-1.728 0-2.376.864l.576 1.8c-1.728.504-.648-2.664-2.376-1.224l-.288-.288c-.504.648-.216 1.584-.288 2.376-.864.36-.648-.504-.936-.864.144-.432-.36-.576-.576-.864-.936-.216-1.224.864-1.8 1.224 0 .288.072.792-.288.936-1.008-1.008.864-3.96-2.088-3.024l-.288.288c-.144-.144-.288-.36-.648-.288 1.224-3.168 4.968-1.368 7.272-2.736 1.584.288 3.816 0 4.248 1.8z"
            ></path>
            <path
              id="path21755"
              fill="#fff"
              d="M87.596 90.1h.288v-.648h-.288z"
            ></path>
            <path
              id="path21757"
              fill="#cedee7"
              d="M73.412 93.412c1.584-.576 1.728-3.96 3.96-1.8-.144 1.08.144 2.088 1.224 2.376.504.504 1.368.36 1.8 0 .648-.864 1.08-.864 1.8-.288.576 1.224 1.728-.216 2.376-.576v-.288h.648c-3.024 3.384-7.488 4.464-11.448 5.976-4.248 2.448-4.392 7.128-4.536 11.448-3.744-4.248-8.568-7.92-12.672-11.448 1.152-2.736 4.824-2.088 6.912-3.888 1.512 0 2.88 1.296 4.248.576-1.008-.432-1.656-1.656-3.024-1.224 1.44-.72 3.096-2.088 3.6-3.6 1.296 1.368 2.736 4.248 5.112 2.736z"
            ></path>
            <path
              id="path21759"
              fill="#bccbd4"
              d="M149.371 97.012c1.368 4.536 2.592 9.072 2.088 14.472-.648.864-1.8 1.368-1.8 2.376-3.24 2.592-7.488 2.88-10.584 5.76-2.376 1.224-4.968 2.376-7.272 3.96-10.584 4.247-20.303 10.727-29.879 17.495-.864-.72-1.44 1.296-2.736.576-1.152.36-1.872-.432-2.736-.864-.504-11.088-.72-23.255 9.936-29.591 11.16-8.496 23.111-14.904 36.143-19.008 3.024-.288 5.184 2.664 6.624 4.824z"
            ></path>
            <path
              id="path21761"
              fill="#000"
              d="M89.684 93.124c-.072.864.216 1.944-.36 2.736l-.288-2.736z"
            ></path>
            <path
              id="path21763"
              fill="#000"
              d="M66.428 97.948c-1.08.072-3.024.072-3.6-1.224 1.224.36 2.592.36 3.6 1.224z"
            ></path>
            <path
              id="path21765"
              fill="#000"
              d="M146.347 100.324c1.152 2.232 1.584 5.112 1.512 7.56.72.648.576 1.728.576 2.736-1.008 1.368-2.376 2.016-3.96 2.088-.864-4.32-1.656-8.712-3.312-12.672l.864-2.088c1.8-.072 3.24 1.152 4.248 2.376z"
            ></path>
            <path
              id="path21767"
              fill="#000"
              d="M138.499 104.572c1.008 3.168 1.872 6.264 1.512 9.936-1.728 1.8-3.816 2.736-6.336 2.736-.144-4.68-.72-9.216-1.8-13.536-.36-1.44.504-2.376 1.224-3.312 1.224-.648 2.52-1.152 3.888-1.224 1.152 1.512 1.008 3.6 1.512 5.4z"
            ></path>
            <path
              id="path21769"
              fill="#f2e2d3"
              d="M146.995 106.66c-.648 1.584 1.44 3.456-.576 4.248l-.576.576c-1.44-3.96-2.016-8.208-3.024-12.312 3.6.576 3.456 4.752 4.248 7.488z"
            ></path>
            <path
              id="path21771"
              fill="#000"
              d="M78.236 102.412l-.288.288c-.648-.576-1.008-1.872-1.8-2.736 1.584-.072 1.224 1.656 2.088 2.376z"
            ></path>
            <path
              id="path21773"
              fill="#f2e2d3"
              d="M77.588 120.844c5.616 2.736 9.648 11.159 16.92 9.647.144-.144.288-.36.576-.288-1.368 1.08.288 3.96-1.512 4.248-4.104-1.368-7.632-5.472-11.448-8.136-8.928-7.199-18.216-15.263-25.92-23.543v-2.376c7.488 5.328 14.616 13.536 21.384 20.52z"
            ></path>
            <path
              id="path21775"
              fill="#fff"
              d="M136.411 100.324c.504 2.016 1.44 3.816 1.512 6.048-1.152.648-2.52 1.008-3.6 2.088-.216-1.224-.792-2.592-.576-3.6-.144-.432-.216-.864-.576-1.224l.288-.288c-.576-.36-.144-1.08 0-1.512.72-1.152 1.872-1.368 3.024-1.512z"
            ></path>
            <path
              id="path21777"
              fill="#000"
              d="M127.051 104.284c.144-.36.576-.288.936-.288l.576.576c.36 5.112 1.728 10.656 1.152 15.408-.72.432-1.512.864-2.088 1.512l-.288-.288c-.864 1.224-2.664 1.512-3.96.864-1.44-.216-1.008-2.16-1.512-3.312.36-.936 0-2.376-.288-3.312-.144-2.52 0-5.04-.935-7.2 1.295-1.872 2.951-3.24 5.111-4.248.36.072.936-.216 1.152.288z"
            ></path>
            <path
              id="path21779"
              fill="#bccbd4"
              d="M73.7 120.844c5.616 4.967 11.808 9.647 17.784 14.471.864.504 2.376.216 3.024.36.072.504-.216 1.224.288 1.512-.504.216-.216.864-.288 1.224l.288.288-.288.288c-13.32-9.936-25.632-21.167-38.304-32.255v-1.512c6.12 4.608 11.664 10.944 17.496 15.696z"
            ></path>
            <path
              id="path21781"
              fill="#fff"
              d="M127.627 109.108v1.8c-1.512 1.008-3.168 1.656-4.824 2.376l-.576-5.112c1.584-.936 2.952-3.312 4.824-2.736l.576 3.6z"
            ></path>
            <path
              id="path21783"
              fill="#f2e2d3"
              d="M138.859 111.196c-1.368.504-2.52 1.728-3.96 2.088l-.648-3.312c1.368-.792 2.736-1.584 4.248-2.088z"
            ></path>
            <path
              id="path21785"
              fill="#fde7dd"
              d="M41.156 110.62c.144.36.576.288.864.288l.36-.288c.576 1.008 1.224-.648 1.8.288-.864.864-1.584 2.664-3.024 3.312-2.232-.072-3.096-1.944-3.96-3.6v-.936c1.368 1.08 2.52.936 3.96.936z"
            ></path>
            <path
              id="path21787"
              fill="#cd9ac5"
              d="M38.996 115.084c-1.152 2.376-4.104 1.656-6.336 1.8l-1.224-.936c.072-.72-.216-2.376.36-3.312.576-1.656 2.376-1.8 3.6-2.736.36 1.8 1.8 4.248 3.6 5.112z"
            ></path>
            <path
              id="path21789"
              fill="#000"
              d="M118.34 110.908c-.504 1.08-.216 1.8-.288 2.736-.576 5.04 5.615 12.671-2.088 15.047-.936-.216-2.952.648-3.6-.864-.072-4.679-1.008-9.071-1.512-13.535 2.448-1.44 4.608-5.904 7.56-3.312z"
            ></path>
            <path
              id="path21791"
              fill="#fff"
              d="M116.54 111.484c.216 1.512.864 2.88.576 4.536-1.224 1.44-2.736 2.016-4.248 3.024-.36-.432-.072-1.152-.576-1.512.432-.864-.864-2.016 0-3.024 1.296-1.368 2.52-2.664 4.248-3.024z"
            ></path>
            <path
              id="path21793"
              fill="#f2e2d3"
              d="M128.563 116.668c-1.584.72-3.384.864-4.824 2.088-1.008-1.008-.504-2.52-.648-3.888 1.8-.432 3.168-2.232 5.112-2.376l.288 4.248z"
            ></path>
            <path
              id="path21795"
              fill="#bccbd4"
              d="M138.859 112.996c.072 2.376-2.808 1.584-3.96 3.024l-.288-.288c.576-1.512 2.736-1.944 4.248-2.736z"
            ></path>
            <path
              id="path21797"
              fill="#cd9ac5"
              d="M57.068 114.796c.504 1.728-1.584 2.376-2.376 3.6h-.576c1.872-.864-.216-5.328 3.024-3.6z"
            ></path>
            <path
              id="path21799"
              fill="#fde7dd"
              d="M51.956 118.468c-1.872-.216-4.248.504-5.76-.648.648-3.528 4.968-.72 6.984-2.376.432 1.368-.792 2.088-1.224 3.024z"
            ></path>
            <path
              id="path21801"
              fill="#bccbd4"
              d="M147.859 118.468c.36 1.152-.72 1.8-.288 3.024-.504-.504-1.44-.216-2.088-.288.36-1.44-1.008-4.104 1.224-4.248 1.152-.504 1.368.72 1.224 1.512z"
            ></path>
            <path
              id="path21803"
              fill="#f2e2d3"
              d="M118.34 122.068c-1.224 1.511-3.168 1.511-4.536 2.735-1.08-.936-.288-2.016-.288-3.023-.504-.576-.864-1.656.288-1.8l3.312-2.088c.864 1.008.864 2.808 1.224 4.248z"
            ></path>
            <path
              id="path21805"
              fill="#000"
              d="M107.756 132.291c-1.44 1.44-3.528 2.736-5.76 3.024-3.96-5.472.792-11.232 2.448-16.271.504-.72 1.224-1.08 2.088-.936z"
            ></path>
            <path
              id="path21807"
              fill="#bccbd4"
              d="M128.563 118.756c-1.008 1.728-2.808 1.368-3.96 2.736-.144-.36-.576-.288-.864-.288v-.576l4.536-2.448c-.072.36.144.504.288.648z"
            ></path>
            <path
              id="path21809"
              fill="#cd9ac5"
              d="M51.668 120.556c-.432 1.296-2.232 2.016-3.312 3.024-.864.431-2.376.431-3.312 0-1.584-.576-.648-2.232-.936-3.312l.936-1.224c1.584 1.44 4.464 1.008 6.624 1.512z"
            ></path>
            <path
              id="path21811"
              fill="#fff"
              d="M105.668 123.579l-2.376 1.512 2.376-4.823v3.311z"
            ></path>
            <path
              id="path21813"
              fill="#a4a6a8"
              d="M148.507 124.803c.144 1.944-1.296 1.872-2.376 3.024-.72-.864-2.52-.504-2.376-2.088.288-1.224.36-2.375 1.8-2.735 1.368-.216 3.24.072 3.024 1.799z"
            ></path>
            <path
              id="path21815"
              fill="#bccbd4"
              d="M114.092 127.755c-.504-.288-.216-1.008-.288-1.512l4.536-2.376c.144 2.52-2.736 2.952-4.248 3.96z"
            ></path>
            <path
              id="path21817"
              fill="#000"
              d="M146.635 124.155c.864.648-.216 1.224-.288 1.8-.36-.072-1.008.216-1.224-.288-.504-1.224.792-1.368 1.512-1.512z"
            ></path>
            <path
              id="path21819"
              fill="#f2e2d3"
              d="M106.244 129.627c-1.44.432-2.448 1.944-3.888 2.376l-.36-4.248c1.152-1.296 2.448-2.232 3.96-2.736l.288 4.536z"
            ></path>
            <path
              id="path21821"
              fill="#bccbd4"
              d="M106.244 131.427c-.432 1.224-2.088 2.088-3.312 2.736l-.288-.288c1.224-.864 2.232-1.944 3.6-2.376z"
            ></path>
            <path
              id="path21823"
              fill="#bccbd4"
              d="M94.508 140.427c-.072.36.216 1.008-.288 1.152.864.504-.432.864 0 1.512.504 1.512.216 3.384.288 5.112-.72-1.008-2.448-.648-3.312-.36l-.288.36-.288-10.584c1.44.648 2.376 2.232 3.96 2.736z"
            ></path>
            <path
              id="path21825"
              fill="#a4a6a8"
              d="M95.084 150.723c.216 1.872-1.368 2.448-2.736 3.024-.504-.864-1.656-.864-1.8-1.8-.36-1.008.576-1.584.864-2.376 1.368-.072 3.024-.072 3.6 1.224z"
            ></path>
            <path
              id="path21827"
              fill="#000"
              d="M93.284 152.163c-.144.36-.576.288-.864.288-.72-.288-.72-1.368-.288-1.8.864 0 1.44.432 1.224 1.512z"
            ></path>
          </g>
          <g id="g21835">
            <path
              id="path21831"
              fill="#000"
              d="M27.621 58.564c3.383 2.376 6.263 4.896 7.631 8.784-.288.144-.288.504-.288.72.432 1.224-.72 2.808-.504 4.032l-1.224 7.344c.288 1.44-.432 2.952-1.152 4.32-.504 1.224-2.016.648-2.879.432l-.72-.72c.36-5.544 1.079-10.944 2.159-16.128l-2.159-2.376-.504.72c-1.152 3.96.576 9-2.376 12.096-.936.144-1.728-.144-2.376-.72-.72-3.024-.72-6.984 0-10.008V64.9c.288-1.44.36-2.952.504-4.536l-2.88-2.376c-.648 3.96.432 8.64-.936 12.312-.504.792-1.656 2.52-2.592 1.224-2.016-2.304-1.224-6.264-.72-9.072 0-2.808-1.08-5.832 0-8.568.072-1.008-1.152-1.152-1.656-1.656-2.304 1.152-.216 4.464-1.224 6.624l.216.216c-.216 2.16-.576 4.176-.504 6.408-.864.648-1.872 1.728-3.096.936l-1.224-1.224c-.288-5.4-.648-11.304 1.224-16.128.936-.864 1.944-1.368 3.096-1.656 5.544 1.584 9.144 7.776 13.968 10.944z"
            ></path>
            <path
              id="path21833"
              fill="#bccbd4"
              d="M17.397 50.5c5.184 8.064 20.951 11.232 15.911 22.824.072.792-.144 2.088-.216 3.096-.144 2.448-.432 5.04-1.656 7.128-1.008.288-1.8-.432-2.159-1.224-.072-.216.143-.36.215-.432l-.215-.216c.431-4.896 1.943-9.36 2.375-14.256-.792-1.512-2.303-3.024-3.815-3.816-.936.648-.144 2.016-.72 2.88.072.792-.144 2.088-.216 3.096.216 2.736-.288 5.256-1.44 7.344-.36.072-.504-.432-.936-.216-1.368-1.584-.288-4.32-.936-6.192l1.152-10.656c-1.368-1.008-2.592-2.52-4.248-3.096l-.72.72c.216 4.32.792 9.36-.72 13.32-.648 0-1.584.144-1.656-.72-.36-5.328-.288-9.36 0-14.76l-.216-.216c.432-.216.144-.792.216-1.224l-.216-.216c.432-.216-.072-.648-.216-.936-.432-1.008-1.512-.504-2.16-.936-.792.072-1.584.864-1.656 1.656.144.144.288.216.288.504v3.096c.36.864-.72 1.44 0 2.16l-.504 6.408c-.576.36-1.512.36-2.16 0l-.432-.504c-.504-4.968-.216-10.296.72-14.976 1.368-2.808 4.824-.936 6.408.504z"
            ></path>
          </g>
          <g id="g21841">
            <path
              id="path21837"
              fill="#000"
              d="M79.964 105.58c4.032 2.304 8.928 5.544 8.568 10.944.504 4.392-.072 8.279.216 12.815-.36 1.224-.216 2.736-1.44 3.312-.648.36-1.728.36-2.376 0a3.238 3.238 0 01-1.44-3.312c-.864-5.615.792-12.239-1.44-17.351-.432 1.152-.216 2.88-.216 3.816l-.216.216c.144 1.008-.288 2.304-.216 3.6-.216 2.88.648 5.327-1.656 7.343-1.512.432-2.232-.864-2.376-1.872-.648-4.967.504-8.855.504-13.967-.144-.864-.144-1.656-.504-2.592-.576-.216-1.224-1.224-1.872-.432.432.864.216 2.376.216 3.096-.72.504.432 1.152-.216 1.656.432 1.44.216 2.808.216 4.752-.072.432.216.936-.216 1.224.648.864-.216 1.728-.216 2.592-.648 1.368-1.872 1.944-3.096.936-.432-.576-.216-1.728-.216-2.16-.72-.504.432-1.224-.216-1.656l.216-.216c-.504-2.736.072-5.112-.432-7.848l.216-.216c-.36-.432-.36-1.224 0-1.656-1.008-1.8 1.224-5.904-1.872-5.688l-.504.504c-.936 3.816-.144 8.352-.72 12.312-.72.864-1.008 1.944-2.376 1.656l-.936-1.224c.504-4.032-.072-8.856.504-12.6-.504-1.44.864-2.736.72-4.32.216-.72.576-1.584 1.44-1.872 5.544-.36 7.776 5.76 12.096 8.28z"
            ></path>
            <path
              id="path21839"
              fill="#bccbd4"
              d="M70.244 98.236c4.896 4.248 9.576 9.072 14.976 12.096 1.944 2.016 2.088 4.752 2.592 7.344-.792 1.008.504 2.088-.216 3.096.792 1.584-.504 3.167.216 4.751-1.08 2.016 1.44 6.48-2.16 6.408-2.664-1.728-.792-5.328-1.656-7.848.36-1.799.36-3.887 0-5.687.72-.504-.432-1.224.216-1.656-.648-2.376.504-5.184-2.592-5.976-.216.288-.72.504-.72.936l.216.216c-.648 4.608-.504 8.928-1.152 13.535-.288.432-.72.504-1.224.432l-.72-1.152c-.432-5.615.792-10.655.72-16.127-.792-1.224-2.232-1.728-3.528-2.16l-.72.936.504 9.72c-.432 1.512-.072 3.312-1.224 4.536h-.72c-.72-2.16-.288-4.896-.72-7.128.432-1.008.216-2.88.216-4.32-.216-2.592-.504-5.328-.432-7.848-.72-.576-1.584-.792-2.592-.72l-.936 1.224c-.936 3.168-.144 6.192-.72 9.504-.072.72.216 2.232-.216 3.096-.144.36-.144.72-.504.936-.432.144-.792-.288-.936-.504l-.288-.216c.648-.432-.216-.792 0-1.44 1.44-5.184-1.08-11.952 2.16-16.344l2.16.216z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default HospitalBed;
